import { useDispatch, useSelector } from 'react-redux';
import { useState, useCallback } from 'react';
import useNotification from '../notification/useNotification';
import { isSuccessResponse } from '../../common/utils';
import {
  IEverbridgeUserState,
  everbridgeToken,
} from './configureEverbridgeTokenSlice';
import { selector as everbridgeTokenApi } from './configureEverbridgeTokenSlice';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { fetchEverbridgeGroupData, selector as getEverbridgeGroup } from "../../pages/integrations/everbridge/listEverbridgeGroupSlice";

interface IEverbridgeTokenResponseState {
  everbridgeTokenApi: IEverbridgeUserState;
}

export const useConfigureEverbridgeTokenModal = () => {
  const [secretKeyId, setSecretKeyId] = useState<string>('');
  const [accessKeyId, setAccessKeyId] = useState<string>('');
  const [organizationId, setOrgId] = useState<string>('');

  const [showModel, setShowModel] = useState<boolean>(false);

  const dispatch: ThunkDispatch<
    IEverbridgeTokenResponseState,
    undefined,
    Action
  > = useDispatch();
  const everbridgeTokenResponse = useSelector(everbridgeTokenApi);
  const everbridgeGroupDetails = useSelector(getEverbridgeGroup).everbridgeGroup;
  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  const handleAddButtonClick = useCallback(() => {
    const configureTokenPayload = {
      secretKeyId: secretKeyId,
      accessKeyId: accessKeyId,
      organizationId: organizationId,
    };
    dispatch(everbridgeToken(configureTokenPayload)).then((response: any) => {
      if (isSuccessResponse(response.payload)) {
        dispatch(fetchEverbridgeGroupData());
        showSuccessNotification(response.payload.message);
      } else {
        showWarningNotification(response.payload.response.data.message);
      }
    });
    setShowModel(false);
  }, [secretKeyId, accessKeyId, organizationId]);

  return {
    handleAddButtonClick,
    showModel,
    handleShow,
    handleClose,
    setSecretKeyId,
    setAccessKeyId,
    setOrgId,
    everbridgeTokenResponse,
    everbridgeGroupDetails,
    secretKeyId,
    accessKeyId,
    organizationId,
  };
};
